import { render, staticRenderFns } from "./SelectCustomerSegments.vue?vue&type=template&id=30649590"
import script from "./SelectCustomerSegments.vue?vue&type=script&lang=js"
export * from "./SelectCustomerSegments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports